export default {
	'misc/connection-error.png': require('@img/misc/connection-error.png'),
	'misc/counter.png': require('@img/misc/counter.png'),
	'misc/error.png': require('@img/misc/error.png'),
	'misc/fullscreen-contract.png': require('@img/misc/fullscreen-contract.png'),
	'misc/fullscreen-expand.png': require('@img/misc/fullscreen-expand.png'),
	'misc/phone.png': require('@img/misc/phone.png'),
	'misc/ready-hand.png': require('@img/misc/ready-hand.png'),
	'misc/ready.png': require('@img/misc/ready.png'),
	'misc/trophy.png': require('@img/misc/trophy.png'),
	'misc/winning-point.png': require('@img/misc/winning-point.png'),
	'misc/lineal_logo.png': require('@img/misc/lineal_logo.png')
}
